import React, { useRef, useEffect } from 'react';
import './styles.css';

const InfiniteSlider = () => {
  const scrollerRef = useRef(null);

  useEffect(() => {
    const scrollers = scrollerRef.current ? [scrollerRef.current] : [];

    if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      addAnimation();
    }

    function addAnimation() {
      scrollers.forEach((scroller) => {
        scroller.setAttribute("data-animated", true);

        const scrollerInner = scroller.querySelector(".scroller__inner");
        const scrollerContent = Array.from(scrollerInner.children);


        scrollerContent.forEach((item) => {
          const duplicatedItem = item.cloneNode(true);
          duplicatedItem.setAttribute("aria-hidden", true);
          scrollerInner.appendChild(duplicatedItem);
        });
      });
    }
  }, []);

  return (
    <>
    <div>
      <h1 className="Skills-Title">Skills</h1>
    </div>
    <div className="scroller" data-speed="slow" ref={scrollerRef}>
      <ul className="tag-list scroller__inner">
        <li>HTML</li>
        <li>CSS</li>
        <li>SASS</li>
        <li>JavaScript</li>
        <li>TypeScript</li>
        <li>JQuery</li>
        <li>React</li>
        <li>Angular</li>
        <li>Node</li>
        <li>Git</li>
        <li>NPM</li>
        <li>Tailwind</li>
        <li>Bootstrap</li>
        <li>GSAP</li>
        <li>Animation</li>
        <li>SweetAlert2</li>
        <li>SwiperJS</li>
        <li>UI/UX</li>
        <li>3D-Models</li>
        <li>THREEJS</li>
        <li>React-Three-Fiber</li>
        <li>React-Three-Drei</li>
        <li>Model-Render</li>
        <li>NextJS In Progress...</li>
        <li>Webpack In Progress...</li>
        <li>Jest In Progress...</li>
        <li>AWS In Progress...</li>
        <li>And keep learning...📚</li>

      </ul>
    </div>
    </>
  );
};

export default InfiniteSlider;


//the same as the infiniteSlider but you can drag with the mouse (but it have a visual bug)

// import React, { useRef, useEffect, useState } from "react";
// import "./styles.css";

// const InfiniteSlider = () => {
//   const scrollerRef = useRef(null);
//   const [isDragging, setIsDragging] = useState(false);
//   const [startX, setStartX] = useState(0);
//   const [scrollLeft, setScrollLeft] = useState(0);

//   useEffect(() => {
//     const scroller = scrollerRef.current;

//     if (!scroller) return;

//     if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
//       addAnimation();
//     }

//     function addAnimation() {
//       scroller.setAttribute("data-animated", true);

//       const scrollerInner = scroller.querySelector(".scroller__inner");
//       const scrollerContent = Array.from(scrollerInner.children);

//       scrollerContent.forEach((item) => {
//         const duplicatedItem = item.cloneNode(true);
//         duplicatedItem.setAttribute("aria-hidden", true);
//         scrollerInner.appendChild(duplicatedItem);
//       });
//     }

//     // Cleanup duplicated items on unmount
//     return () => {
//       const scrollerInner = scroller.querySelector(".scroller__inner");
//       Array.from(scrollerInner.children)
//         .slice(scrollerInner.children.length / 2)
//         .forEach((child) => scrollerInner.removeChild(child));
//     };
//   }, []);

//   const handleMouseDown = (e) => {
//     setIsDragging(true);
//     const scroller = scrollerRef.current;
//     setStartX(e.pageX - scroller.offsetLeft);
//     setScrollLeft(scroller.scrollLeft);
//     scroller.style.scrollBehavior = "auto"; // Disable smooth scrolling
//   };

//   const handleMouseMove = (e) => {
//     if (!isDragging) return;

//     e.preventDefault();
//     const scroller = scrollerRef.current;
//     const x = e.pageX - scroller.offsetLeft;
//     const walk = (x - startX) * 2; // Adjust multiplier for faster/slower scrolling
//     scroller.scrollLeft = scrollLeft - walk;
//   };

//   const handleMouseUp = () => {
//     setIsDragging(false);
//     const scroller = scrollerRef.current;
//     scroller.style.scrollBehavior = "smooth"; // Re-enable smooth scrolling
//   };

//   return (
//     <div
//       className="scroller"
//       data-speed="slow"
//       ref={scrollerRef}
//       onMouseDown={handleMouseDown}
//       onMouseMove={handleMouseMove}
//       onMouseUp={handleMouseUp}
//       onMouseLeave={handleMouseUp} // Stop dragging if the mouse leaves the container
//     >
//       <ul className="tag-list scroller__inner">
//         <li>HTML</li>
//         <li>CSS</li>
//         <li>JS</li>
//         <li>GSAP</li>
//         <li>SwiperJS</li>
//         <li>React-Three-Drei</li>
//         <li>Animation</li>
//         <li>UI/UX</li>
//         <li>React</li>
//         <li>THREEJS</li>
//         <li>React-Three-Fiber</li>
//         <li>Frontend-Dev</li>
//         <li>WebGL</li>
//         <li>JQuery</li>
//         <li>Bootstrap</li>
//         <li>SweetAlert2</li>
//         <li>ModelRender</li>
//       </ul>
//     </div>
//   );
// };

// export default InfiniteSlider;
